import TopicCreate from './create';
import TopicList from './list';
import TopicShow from './show';
import TopicEdit from './edit';

export default {
    create: TopicCreate,
    list: TopicList,
    show: TopicShow,
    edit: TopicEdit
};